import { ChangeEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import "./Account.css"
import { sendEmailToResetPassword } from '../../api/auth';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [err, setError] = useState<string>('');
  const [isValidEmail, setValidEmail] = useState<boolean>(true)
  const [successText, setSuccessText] = useState<string>("")




  const handleButtonClick = async () => {
    const forgetPasswordApi = await sendEmailToResetPassword(email).then((data) => {
      setValidEmail(true);
      setSuccessText(data.data.message)
      setError("");

    }).catch((e) => {
      setError(e.response.data.message)
      setValidEmail(false);
    });

  }


  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setError("");
    setSuccessText("")
    setValidEmail(true);


  }

  const handleBackButton = () => {
    navigate('/');
  }

  return (
    <div className='login d-flex'>
      <div className="actionBar">
        <button className='backBtn btnNoStyle'>
          <img src={`./assets/images/arrow-left.png`} onClick={handleBackButton} alt="leftArrow" />
        </button>
      </div>
      <div className="imgContent verifyEmail">
        <div className="imgBox">
          <img src={`./assets/images/galaxy.png`} alt="galaxy" />
        </div>
        <div className="h3">We’ll send an email to reset your password</div>
        <div className='loginForm'>
          <div className="formRow">
            <input className={isValidEmail ? 'formControl text-center' : "formControl text-center error"} type='text' placeholder='Admin email' name='email' onChange={handleChange} autoComplete="off" />
            <p className='errorText error'>{err}</p>
            <p className='errorText success'>{successText}</p>



          </div>
        </div>
      </div>

      <div className='bottomBlock d-flex justify-content-center'>
        <button className='blueBtn' type="submit" onClick={handleButtonClick} >Send Email</button>
      </div>
    </div>
  )
}

export default VerifyEmail;